export const WEIGHT_MAX_INTEGRAL_PART = 6;
export const WEIGHT_MAX_FRACTIONAL_PART = 2;
